import { SearchableMenu } from 'components/AdminConsole/commonUI/SearchableMenu'
import useLocaleText from 'components/useLocaleText'
import { isNumber } from 'lodash'
import React from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import { CAMPAIGN_TYPES, CampaignTypes } from '../utils'
import { StyledFormControl, StyledFormLabel } from 'components/AdminConsole/commonUI/styles'
import { FormErrorMessage, Text } from '@chakra-ui/core'
import { PackageOpen } from 'lucide-react'

export const CompaignType = () => {
  const { control, errors, setValue, getValues } = useFormContext()
  const compaignType = getValues('campaign_type')
  const t_campaign_type = useLocaleText('campaign_type', true)
  const error_compaign_type = useLocaleText('error_compaign_type', true)
  const admin_select_placeholder = useLocaleText('admin_select_placeholder')

  return (
    <StyledFormControl isInvalid={!!errors.campaign_type} w={{ base: '100%', md: '50%' }}>
      <StyledFormLabel required>
        <PackageOpen size={18} strokeWidth={2.5} />
        <Text>{t_campaign_type}</Text>
      </StyledFormLabel>
      <Controller
        name="campaign_type"
        control={control}
        rules={{ required: error_compaign_type }}
        as={
          <SearchableMenu
            isInvalid={!!errors.campaign_type}
            isShowSearch={false}
            items={CAMPAIGN_TYPES}
            selectedId={isNumber(compaignType) ? compaignType?.toString() : CampaignTypes.POTENTIALS.toString()}
            placeholder={admin_select_placeholder}
            isLocalTranslation={true}
            onSelect={(item) => {
              setValue('campaign_type', Number(item.id))
            }}
          />
        }
      />

      <FormErrorMessage>{errors.campaign_type && errors.campaign_type.message}</FormErrorMessage>
    </StyledFormControl>
  )
}
